import { Footer, S_Footer } from "component_old/macro/layout/Footer"
import { FooterEnd } from "component_old/macro/layout/footer/FooterEnd"
import { TextBodyContent } from "component_old/macro/layout/textpage/TextBodyContent"
import { TextHeaderMobile } from "component_old/macro/layout/textpage/TextHeaderMobile"
import { TextHeaderWide } from "component_old/macro/layout/textpage/TextHeaderWide"
import { PageWrapper } from "component_old/pageWrapper/PageWrapper"
import { EColors } from "libs/style/styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  title: string
  date: string
  image: string
  imageDescription: string
  htmlContent: React.ReactNode
}

export const BlogPostDetailPage = (props: Props): JSX.Element => {
  const date = new Intl.DateTimeFormat().format(new Date(props.date))

  return (
    <PageWrapper>
      <S_BlogPostDetailPage>
        <TextHeaderMobile />
        <TextHeaderWide />
        <S_TextBodyContent>
          <>
            <BlogTitle>{props.title}</BlogTitle>
            <BlogDate>{date}</BlogDate>
            <BlogImage
              src={props.image}
              alt={props.imageDescription}
              title={props.imageDescription}
            />
            {props.htmlContent}
          </>
        </S_TextBodyContent>
        <Footer />
        <FooterEnd />
      </S_BlogPostDetailPage>
    </PageWrapper>
  )
}

const S_BlogPostDetailPage = styled.div`
  width: 100%;
  background-color: ${EColors.GREY1};
  display: flex;
  flex-direction: column;
  ${S_Footer} {
    margin: 75px 0 0 0;
  }
  @media only screen and (min-width: 1260px) {
    margin: auto;
    max-width: 1920px;
  }
`

const S_TextBodyContent = styled(TextBodyContent)`
  width: 800px;
  max-width: 100%;
  margin: 0 auto;
  line-height: 30px;
  h2,
  h3,
  h4 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  h2 {
    margin-top: 30px;
    font-size: 22px;
  }
  h3 {
    margin-top: 25px;
    font-size: 20px;
  }
  h4 {
    margin-top: 25px;
    font-size: 18px;
  }
  p {
    line-height: 30px;
  }
  img {
    width: 650px;
    max-width: 100%;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  strong {
    font-family: "InterBold";
    a {
      font-family: "InterBold";
    }
  }
  a {
    font-family: "InterBold";
    text-decoration: underline;
    color: ${EColors.DARK};
    &:hover {
      text-decoration: underline;
      color: ${EColors.DARK};
    }
  }
  iframe {
    max-width: 100%;
    width: 800px;
    height: 500px;
    margin-bottom: 20px;
  }
  p,
  ul,
  ol {
    margin-bottom: 15px;
  }
  ul {
    list-style-type: disc;
    padding-left: 14px;
  }
  ol {
    padding-left: 19px;
    li {
      padding-left: 15px;
    }
  }
`

const BlogTitle = styled.h1`
  text-align: center;
`

const BlogDate = styled.p`
  text-align: center;
`

const BlogImage = styled.img`
  text-align: center;
  margin-bottom: 20px;
  width: 100%;
  max-width: 100%;
  height: auto;
`
